import { Outlet } from 'react-router-dom';
import LoginStage from '../components/auth/LoginStage';

/**
 * AuthLayout — every /login and /forgot-password child renders inside the
 * LoginStage variant chooser. Each variant supplies its own language
 * switcher and brand mark.
 */
export default function AuthLayout() {
  return (
    <div data-testid="auth-layout">
      <LoginStage>
        <Outlet />
      </LoginStage>
    </div>
  );
}
